const TransferInGameStateReducer = (state = "ready", action) => {
  /**
   * 判斷轉進遊戲的狀態
   * ready: 準備中(預設狀態)
   * pending: 處理中
   */
  switch (action.type) {
    case "TRANSFER_PENDING":
      return "pending";
    case "TRANSFER_READY":
      return "ready";
    default:
      return state;
  }
};
export default TransferInGameStateReducer;
